module.exports = __webpack_public_path__ + "img/big_1_20.fc6ff04b.png";